import { Link } from 'react-router-dom';

export default function Name(props) {
  return (
    <div id="name">
      <h2>Los geht's: Wie heißt Du?</h2>
      <div className="ccontent">
        <label htmlFor="prename">Vorname</label>
        <input type="text" name="prename" size="15" placeholder="Vorname" onChange={(e) => props.setPrename(e.target.value)} required></input>
        <label htmlFor="surname">Nachname</label>
        <input type="text" name="surname" size="15" placeholder="Nachname" onChange={(e) => props.setSurname(e.target.value)} required></input>
      </div>
      { (props.prename && props.surname) && <Link className="ui button" to='/kontakt'>Weiter</Link> }
      { (!props.prename || !props.surname) && <Link className="ui button disabled">Weiter</Link> }
    </div>
  )
} 